/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  /* ========================================================================
         BRAVE CUSTOM CODE
  * ======================================================================== */
  function debounce(func, wait, immediate) {
      var timeout;
      return function() {
          var context = this, args = arguments;
          var later = function() {
              timeout = null;
              if (!immediate) {func.apply(context, args);}
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow){func.apply(context, args);}
      };
  }

  // Searchbar toggle
    var slideout = $('#searchBar');

    $("#searchToggle").click(function () {
        // use cached object instead of searching
        slideout.toggleClass('active');
    });

  /* ========================================================================
   END BRAVE CUSTOM CODE
   * ======================================================================== */

   function mainHeight() {
     var $wrap = $('.wrap, .sidebar, .main');
     var subtractions = $('.wrap').offset().top + $('footer.footer').outerHeight();
     $wrap.css('min-height', 'calc(100vh - ' + subtractions + 'px)');
   }

   function sidebarHeight() {
     // Match height of sidebar and main
     var $sidebar = $('.sidebar');
     var $main = $('.main');

     $sidebar.height('auto'); $main.height('auto');

     if (($sidebar.length > 0) && $(window).width() > 600) {
       var max = Math.max($sidebar.height(true), $main.height(true));
       $sidebar.height(max); $main.height(max);
     }
   }

   function equalHeightGrid() {
     // Match height of rows in the grid.
     $('.equal-height-panel-grid' ).each(function(index, el) {
       $(this).find('.panel-grid-cell').css('height','');
       $(this).find('.panel-grid-cell').matchHeight();
     });

     $('.equal-height-grid' ).each(function(index, el) {
       $(this).find('.grid-cell').css('height','');
       $(this).find('.grid-cell').matchHeight();
     });

   }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $(document).ready(function() {
          // RESPONSIVE FUNCTIONS
          mainHeight();
          sidebarHeight();
          equalHeightGrid();

          $(window).on('resize', function(event) {
            event.preventDefault();
            debounce( mainHeight(), 200);
            debounce( sidebarHeight(), 200);
            debounce( equalHeightGrid(), 200);
          });

          // POST GRID ITEM - BUTTONS
          // $('.brave-post-widget.has-background .cover-text').hover( function() {
          //     $(this).find('.btn').slideDown(100);
          //   }, function() {
          //     $(this).find('.btn').slideUp(200);
          //   }
          // );

        });

      },
      finalize: function() {

        $(window).scroll(function() {
        // 100 = The point you would like to fade the nav in.

        	if ($(window).scrollTop() > 200 ){

         		$('.navbar-cpg').addClass('scrolled');

          } else {

            $('.navbar-cpg').removeClass('scrolled');

         	};
        });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
